module.exports = __webpack_public_path__ + "img/Sara Amin Co-Director Marketing Schulich Finance Association.1746ed43.webp";